(() => {
  if (window.gtLandingMotionInitialized) return;
  window.gtLandingMotionInitialized = true;

  const selector = '.gt-landing';
  const revealSelector = [
    '.gt-review-intro .gt-big-title',
    '.gt-review-intro .gt-intro-spacing',
    '.gt-steps-grid .gt-step',
    '.gt-analysis-heading',
    '.gt-analysis-row',
    '.gt-price-heading',
    '.gt-price-card',
    '.gt-plan-step'
  ].join(', ');
  const observers = new WeakMap();

  const init = root => {
    if (observers.has(root) || !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const elements = [...root.querySelectorAll(revealSelector)];
    if (!elements.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elements.forEach(element => {
      element.classList.add('gt-reveal');
      if (element.getBoundingClientRect().top < window.innerHeight * 0.9) {
        element.classList.add('is-visible');
      } else {
        observer.observe(element);
      }
    });

    root.classList.add('gt-motion-ready');
    observers.set(root, observer);
  };

  const findRoots = element => {
    if (element.matches?.(selector)) init(element);
    element.querySelectorAll?.(selector).forEach(init);
  };

  findRoots(document);
  document.addEventListener('shopify:section:load', event => findRoots(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    observers.get(root)?.disconnect();
  });
})();
